document.addEventListener('DOMContentLoaded', () => {
  const lineDuration = 2000;

  // ── Desktop (horizontal) ──────────────────────────────────────
  const desktopContainer = document.querySelector('.bosTimelineContainer');
  const desktopBar = document.querySelector('.bosTimelineBar');
  const desktopItems = document.querySelectorAll('.bosTimelineContainer .bosTimelineItem');

  if (desktopContainer && desktopBar && desktopItems.length) {
    const desktopObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const containerRect = desktopContainer.getBoundingClientRect();

            const dots = [...desktopItems].map((item) =>
              item.querySelector('.bosTimelineItemInnerDot')
            );

            if (dots.some((d) => !d)) {
              console.warn('[bosTimeline] Missing .bosTimelineItemInnerDot on desktop item(s).');
              return;
            }

            const dotRects = dots.map((d) => d.getBoundingClientRect());
            const firstDotRect = dotRects[0];
            const lastDotRect = dotRects[dotRects.length - 1];

            const barStart = firstDotRect.left + firstDotRect.width / 2 - containerRect.left;
            const barEnd = lastDotRect.left + lastDotRect.width / 2 - containerRect.left;
            const barWidth = barEnd - barStart;

            const barTop =
              dotRects.reduce(
                (sum, r) => sum + (r.top + r.height / 2 - containerRect.top),
                0
              ) / dotRects.length;

            if (!Number.isFinite(barStart) || !Number.isFinite(barWidth) || !Number.isFinite(barTop)) {
              console.warn('[bosTimeline] Invalid desktop bar measurement, aborting.', {
                barStart,
                barWidth,
                barTop,
              });
              return;
            }

            desktopBar.style.top = barTop + 'px';
            desktopBar.style.left = barStart + 'px';
            desktopBar.style.width = barWidth + 'px';
            desktopBar.classList.add('is-animating');

            desktopItems.forEach((item, i) => {
              const dotRect = dotRects[i];
              const dotCentre = dotRect.left + dotRect.width / 2 - containerRect.left;
              const fraction = barWidth === 0 ? 0 : (dotCentre - barStart) / barWidth;
              setTimeout(() => {
                item.classList.add('is-visible');
              }, fraction * lineDuration);
            });

            desktopObserver.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    );

    desktopObserver.observe(desktopContainer);
  }

  // ── Mobile (vertical) ────────────────────────────────────────
  const mobileContainer = document.querySelector('.bosTimelineContainerMobile');
  const mobileBar = document.querySelector('.bosTimelineBarMobile');
  const mobileItems = document.querySelectorAll('.bosTimelineItemMobile');

  if (mobileContainer && mobileBar && mobileItems.length) {
    const mobileObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const containerRect = mobileContainer.getBoundingClientRect();

            const dots = [...mobileItems].map((item) =>
              item.querySelector('.bosTimelineItemInnerDot')
            );

            if (dots.some((d) => !d)) {
              console.warn('[bosTimeline] Missing .bosTimelineItemInnerDot on mobile item(s).');
              return;
            }

            const dotRects = dots.map((d) => d.getBoundingClientRect());
            const firstDotRect = dotRects[0];
            const lastDotRect = dotRects[dotRects.length - 1];

            const barStart = firstDotRect.top + firstDotRect.height / 2 - containerRect.top;
            const barEnd = lastDotRect.top + lastDotRect.height / 2 - containerRect.top;
            const barHeight = barEnd - barStart;

            const barLeft =
              dotRects.reduce(
                (sum, r) => sum + (r.left + r.width / 2 - containerRect.left),
                0
              ) / dotRects.length;

            if (!Number.isFinite(barStart) || !Number.isFinite(barHeight) || !Number.isFinite(barLeft)) {
              console.warn('[bosTimeline] Invalid mobile bar measurement, aborting.', {
                barStart,
                barHeight,
                barLeft,
              });
              return;
            }

            mobileBar.style.left = barLeft + 'px';
            mobileBar.style.top = barStart + 'px';
            mobileBar.style.height = barHeight + 'px';
            mobileBar.classList.add('is-animating');

            mobileItems.forEach((item, i) => {
              const dotRect = dotRects[i];
              const dotCentre = dotRect.top + dotRect.height / 2 - containerRect.top;
              const fraction = barHeight === 0 ? 0 : (dotCentre - barStart) / barHeight;
              setTimeout(() => {
                item.classList.add('is-visible');
              }, fraction * lineDuration);
            });

            mobileObserver.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    );

    mobileObserver.observe(mobileContainer);
  }
});